import { Title1 } from '@fluentui/react-components';

export default function CRM() {
  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        
      </div>
    </div>
  );
}